import script from "./TheWppLogoFlashing.vue?vue&type=script&setup=true&lang=js"
export * from "./TheWppLogoFlashing.vue?vue&type=script&setup=true&lang=js"

import "./TheWppLogoFlashing.vue?vue&type=style&index=0&id=cad41bd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cad41bd2"]])

export default __exports__